export default __webpack_public_path__ + "static/media/debate_19.2782cd98.JPG";